/* eslint-disable camelcase */
import { getHeaders } from 'contexts/api'

export const createContactMessage = () => ({
  suffix: `contact_messages`,
  method: 'POST',
  cachable: false,
  headers: getHeaders({ namespace: 'picto-public' }),
})
